module.exports = __webpack_public_path__ + "static/media/play-button.8d1cc462.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/play-button.svg
// module id = 391
// module chunks = 0